import axios from 'axios'

const baseUrl = process.env.REACT_APP_API_URL;

// __________get users ___________

const getUser = async (page) => {
  const path = `/api/user/getAllUsers/${page || ''}`
  const url = baseUrl + path
  const response = await axios.get(url)
  return response?.data
}

const getLastFiveUser = async (page) => {
  try {
    const path = `/api/user/getTopFiveUsers`
    const url = baseUrl + path
    const response = await axios.get(url)
    return response?.data
  } catch (e) {
    console.log(e)
  }
}

const deleteAllUser = async (data) => {
  const path = `/api/user/deleteMultipleUser`
  const url = baseUrl + path
  const dataaa = [...data]
  const response = await axios.post(url, dataaa)
  return response.data
}

// delete user;
const deleteUser = async (id) => {
  const { userid } = JSON.parse(localStorage.getItem('user'))

  if (userid === id) {
    localStorage.removeItem('user')
    setTimeout(() => {
      window.location.reload()
    }, 2000)
  }

  const path = `/api/user/deleteUser/${id}`
  const url = baseUrl + path
  const response = await axios.post(url)
  return response.data
}

// view user;
const viewUser = async (id) => {
  const data = {
    userId: id,
  }
  const path = '/api/user/getUserDetail'
  const url = baseUrl + path
  const response = await axios.post(url, data)
  return response?.data
}

const editUser = async (dataa) => {
  const { userid } = JSON.parse(localStorage.getItem('user'))
  const data = {
    password: dataa?.password,
    email: dataa?.email,
    name: dataa?.name,
    userId: dataa?.userId || userid,
    status: dataa.status,
    roles: dataa.roles,
    user_status: dataa?.user_status,
  }
  const path = '/api/user/updateUser'
  const url = baseUrl + path
  const response = await axios.post(url, data)
  return response.data
}

// dashboard user data
const showingDashboardUser = async (id) => {
  const path = '/api/user/dashboardetail'
  const url = baseUrl + path
  const response = await axios.get(url)
  return response.data
}

const userLogList = async (page) => {
  const path = `/api/user/getAllUserLogin/${page || ''}`
  const url = baseUrl + path
  const response = await axios.get(url)
  return response.data
}

// Profile / general
const updataProfileState = async (data) => {
  const { userid } = JSON.parse(localStorage.getItem('user'))

  // console.log('hello', data)
  const path = '/api/user/updateProfile'
  const url = baseUrl + path
  const datas = JSON.stringify(data)
  const useriId = JSON.stringify(userid)


  const bodyFormData = new FormData()
  bodyFormData.append('picture', data?.photoURL)
  bodyFormData.append('profile', datas)
  bodyFormData.append('userId', useriId)

  await axios.put(url, bodyFormData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer`,
    },
  })
}

const savePassword = async (data) => {
  const { token, userid } = JSON.parse(localStorage.getItem('user'))
  const password = data?.password
  const password_confirmation = data?.password_confirmation
  const userId = userid
  const headingCustomizationData = {
    password,
    password_confirmation,
    userId
  }

  const path = `/api/user/updateSecurity`
  const url = baseUrl + path
  const response = await axios.post(url, headingCustomizationData, {
    headers: {
      Authorization: `'Bearer ' ${token}`,
    },
    
  })

  return response.data
}

const savePageName = async (data) => {
  const { token } = JSON.parse(localStorage.getItem('user'))
  const pageName = data?.pageName
  const userId = data?.userId
// console.log('checking pagename ----', pageName);
  const headingCustomizationData = {
    pageName,
    userId
  }

  const path = `/api/user/savePageName`
  const url = baseUrl + path
  const response = await axios.post(url, headingCustomizationData, {
    headers: {
      Authorization: `'Bearer ' ${token}`,
    },
    
  })

  return response.data
}

const saveAccountDetail = async (data) => {
  const { token } = JSON.parse(localStorage.getItem('user'))
  const firstName = data?.firstName
  const lastName = data?.lastName
  const email = data?.email
  const accountType = data?.accountType
  const country = data?.country
  const province = data?.province
  const city = data?.city
  const zipCode = data?.zipCode
  const userId = data?.userId
  const headingCustomizationData = {
    firstName,
    lastName,
    email,
    accountType,
    country,
    province,
    city,
    zipCode,
    userId
  }
  // console.log('checking account save data ----', headingCustomizationData);

  const path = `/api/user/updateProfile`
  const url = baseUrl + path
  const response = await axios.post(url, headingCustomizationData, {
    headers: {
      Authorization: `'Bearer ' ${token}`,
    },
    
  })

  return response.data
}

const userServices = {
  getUser,
  deleteAllUser,
  deleteUser,
  viewUser,
  editUser,
  showingDashboardUser,
  getLastFiveUser,
  updataProfileState,
  userLogList,
  savePageName,
  saveAccountDetail,
  savePassword
}

export default userServices
